/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

const accountMenuItems: FuseNavigationItem[] = [
    {
        id: 'account.profile',
        title: 'My Profile',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/account/profile'
    },
    // {
    //     id: 'account.accountSettings',
    //     title: 'My Account Settings',
    //     type: 'basic',
    //     icon: 'heroicons_outline:cog-8-tooth',
    //     link: '/account/account-settings'
    // },
    // {
    //     id  : 'divider-2',
    //     type: 'divider'
    // },
    {
        id: 'settings.logout',
        title: 'Sign out',
        type: 'basic',
        icon: 'feather:log-out',
        link: '/sign-out'
    }
];

const singleLevelNav: FuseNavigationItem[] = [
    {
        id      : 'dashboard',
        title   : 'Dashboard',
        subtitle: 'Your application overview',
        type    : 'basic',
        icon    : 'heroicons_outline:home',
        link: '/dashboard',
    },
    // {
    //     id  : 'divider-1',
    //     type: 'divider'
    // },
    {
        id: 'account.profile',
        title: 'My Profile',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/account/profile'
    },
    {
        id: 'account.accountSettings',
        title: 'My Account Settings',
        type: 'basic',
        icon: 'heroicons_outline:cog-8-tooth',
        link: '/account/account-settings'
    },
    // {
    //     id  : 'divider-2',
    //     type: 'divider'
    // },
    {
        id: 'settings.logout',
        title: 'Sign out',
        type: 'basic',
        icon: 'feather:log-out',
        link: '/sign-out'
    }
];

const multiLevelNav: FuseNavigationItem[] = [
    {
        id      : 'dashboard',
        title   : 'Dashboard',
        subtitle: 'Your application overview',
        type    : 'basic',
        icon    : 'heroicons_outline:home',
        link    : '/dashboard',
    },
    // {
    //     id      : 'form-vault',
    //     title   : 'Form Vault',
    //     subtitle: 'Search the forms library',
    //     type    : 'basic',
    //     icon    : 'heroicons_outline:building-library',
    //     link    : '/form-vault'
    // },
    {
        id  : 'divider-1',
        type: 'divider'
    },
    {
        id      : 'my-account',
        title   : 'My Account',
        subtitle: 'Manage your account',
        type    : 'collapsable',
        icon    : 'heroicons_outline:user-circle',
        children: accountMenuItems
    }
];

const dropDownNav: FuseNavigationItem[] = [
    {
        id      : 'dashboard',
        title   : 'Dashboard',
        subtitle: 'Your application overview',
        type    : 'basic',
        icon    : 'heroicons_outline:home',
        link    : '/dashboard',
    },
    // {
    //     id      : 'form-vault',
    //     title   : 'Form Vault',
    //     subtitle: 'Search the forms library',
    //     type    : 'basic',
    //     icon    : 'heroicons_outline:building-library',
    //     link    : '/form-vault'
    // },
    {
        id  : 'divider-1',
        type: 'divider'
    },
    {
        id      : 'my-account',
        title   : 'My Account',
        subtitle: 'Manage your account',
        type    : 'group',
        icon    : 'heroicons_outline:user-circle',
        children: accountMenuItems
    }
];

const publicNav: FuseNavigationItem[] = [
    // {
    //     id      : 'form-vault',
    //     title   : 'Form Vault',
    //     subtitle: 'Search the forms library',
    //     type    : 'basic',
    //     icon    : 'heroicons_outline:building-library',
    //     link    : '/form-vault'
    // },
    // {
    //     id  : 'divider-1',
    //     type: 'divider'
    // },
    {
        id: 'settings.login',
        title: 'Sign in',
        type: 'basic',
        icon: 'feather:log-in',
        link: '/sign-in'
    }
];

const guestNav: FuseNavigationItem[] = [
    // {
    //     id      : 'form-vault',
    //     title   : 'Form Vault',
    //     subtitle: 'Search the forms library',
    //     type    : 'basic',
    //     icon    : 'heroicons_outline:building-library',
    //     link    : '/form-vault'
    // },
    {
        id: 'settings.logout',
        title: 'Sign out',
        type: 'basic',
        icon: 'feather:log-out',
        link: '/sign-out'
    }
];

export const defaultNavigation: FuseNavigationItem[] = multiLevelNav;
export const compactNavigation: FuseNavigationItem[] = singleLevelNav;
export const futuristicNavigation: FuseNavigationItem[] = singleLevelNav;
export const horizontalNavigation: FuseNavigationItem[] = dropDownNav;
export const publicNavigation: FuseNavigationItem[] = publicNav;
export const guestNavigation: FuseNavigationItem[] = guestNav;
